var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"million-read-user-center-block-title"},[_vm._v("\n  "+_vm._s(_vm.title)),(_vm.count !== 0)?[_vm._v("·"+_vm._s(_vm.count))]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }